const CHANNEL_NAME = 'insolitum-auth';

export type AuthBroadcastEvent = { type: 'signed_out' } | { type: 'user_changed'; userId: string };

type Listener = (event: AuthBroadcastEvent) => void;

let channel: BroadcastChannel | null = null;
const listeners = new Set<Listener>();

function getChannel(): BroadcastChannel | null {
  if (typeof window === 'undefined') return null;
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.addEventListener('message', (event: MessageEvent<AuthBroadcastEvent>) => {
      const data = event.data;
      if (!data || typeof data !== 'object' || !('type' in data)) return;
      for (const listener of listeners) {
        try {
          listener(data);
        } catch (error) {
          console.warn('authBroadcast listener error:', error);
        }
      }
    });
  }
  return channel;
}

export function broadcastAuthEvent(event: AuthBroadcastEvent): void {
  const ch = getChannel();
  if (!ch) return;
  try {
    ch.postMessage(event);
  } catch (error) {
    console.warn('Failed to broadcast auth event:', error);
  }
}

export function subscribeAuthBroadcast(listener: Listener): () => void {
  getChannel();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
